module.exports = __webpack_public_path__ + "img/frame-shuffle-icon.d82c2381.svg";